export default __webpack_public_path__ + "4f0a629874820b2f1158681e90204cb6.jpg";